// src/contexts/UserContext.js
import React, { createContext, useState, useCallback, useContext } from 'react';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
    // Initialize from sessionStorage so user is available synchronously after login
    // (avoids race condition where Navigate fires before context propagates)
    const [user, setUserState] = useState(() => {
        try {
            const stored = localStorage.getItem('userData');
            return stored ? JSON.parse(stored) : null;
        } catch { return null; }
    });

    // Wrap setUser to keep sessionStorage in sync
    const setUser = useCallback((userData) => {
        if (userData) {
            localStorage.setItem('userData', JSON.stringify(userData));
        } else {
            localStorage.removeItem('userData');
        }
        setUserState(userData);
    }, []);

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);

export default UserContext;
